var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckOut(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7CB3E523-D6D0-4727-9416-3737C3C9A23E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EID---MRD---Resource-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resource-Admin---Applications---Details---Client-Secrets---Details",
    transform: "translate(-772.000000, -714.000000)",
    stroke: "currentColor",
    strokeWidth: 1.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "p/drawer/resource-admin/applications/client-secrets-details-overview",
    transform: "translate(718.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "o/details-cta-block/resource-admin/applications-client-secret",
    transform: "translate(0.000000, 650.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(30.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a/icons/20/check-in",
    transform: "translate(24.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88888889,18 L17.1111111,18 C17.6020444,18 18,17.6020445 18,17.1111112 L18,10 L18,2.88888973 C18,2.3979742 17.6020444,2 17.1111111,2 L2.88888889,2 C2.39797333,2 2,2.39796531 2,2.88888973 L2,17.1111112 C2,17.6020445 2.39797333,18 2.88888889,18 Z",
    id: "Box",
    transform: "translate(10.000000, 10.000000) rotate(-180.000000) translate(-10.000000, -10.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,9.5 L2.45833333,9.5 M2,9.5 L6.58333333,14 M2,9.5 L6.58333333,5",
    id: "Arrow",
    strokeLinecap: "square",
    transform: "translate(7.500000, 9.500000) rotate(-180.000000) translate(-7.500000, -9.500000) "
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOut);
export default __webpack_public_path__ + "static/media/check-out.2d985b6deb94824437f7eed2396ea650.svg";
export { ForwardRef as ReactComponent };